/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ExamLangsExamlangidItems200,
  GetApiV1ExamLangsExamlangidItems401,
  GetApiV1ExamLangsExamlangidItems404,
  GetApiV1ExamLangsExamlangidItems500,
  GetApiV1ExamLangsExamlangidItemsPathParams,
  GetApiV1ExamLangsExamlangidItemsQueryParams,
  GetApiV1ExamLangsExamlangidItemsQueryResponse,
} from "../../types/examEvaluationController/GetApiV1ExamLangsExamlangidItems.ts";
import { examItemLangGridItemViewModelSchema } from "../examItemLangGridItemViewModelSchema.ts";

export const getApiV1ExamLangsExamlangidItemsPathParamsSchema = z.object({
  examLangId: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1ExamLangsExamlangidItemsPathParams>;

export const getApiV1ExamLangsExamlangidItemsQueryParamsSchema = z.object({
  pageNumber: z.coerce.number().int().default(1),
  pageSize: z.coerce.number().int().default(20),
  sortField: z.optional(z.string()),
  sortDirection: z.optional(z.string()),
}) as unknown as ToZod<GetApiV1ExamLangsExamlangidItemsQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ExamLangsExamlangidItems200Schema = z.array(
  z.lazy(() => examItemLangGridItemViewModelSchema),
) as unknown as ToZod<GetApiV1ExamLangsExamlangidItems200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ExamLangsExamlangidItems401Schema =
  z.any() as unknown as ToZod<GetApiV1ExamLangsExamlangidItems401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1ExamLangsExamlangidItems404Schema =
  z.any() as unknown as ToZod<GetApiV1ExamLangsExamlangidItems404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ExamLangsExamlangidItems500Schema =
  z.any() as unknown as ToZod<GetApiV1ExamLangsExamlangidItems500>;

export const getApiV1ExamLangsExamlangidItemsQueryResponseSchema = z.lazy(
  () => getApiV1ExamLangsExamlangidItems200Schema,
) as unknown as ToZod<GetApiV1ExamLangsExamlangidItemsQueryResponse>;
